import TabSwitcher from './TabSwitcher';

export type { TabOption, TabSwitcherProps } from './TabSwitcher';
export default TabSwitcher;
